import React from 'react';
import { TabF, TabsF } from 'components/tabs/tabfile';

const PayslipManagementSubNav = () => {
  return (
    <TabsF>
      <TabF label={'payslips'} tabName={'Fiches de paie'} />
      <TabF label={'invoices'} tabName={'Factures client'} />
      <TabF label={'history'} tabName={'Historique'} />
      <TabF label={'stats'} tabName={'Statistiques'} />
    </TabsF>
  );
};

export default PayslipManagementSubNav;
